<template>
  <LessonContent :title="lesson.title" :order="lesson.order">

     <form-wizard class="mt-3 lesson-wizard"  color="black" errorColor="rgba(var(--vs-danger), 1)" backButtonText="<" title="" subtitle="" nextButtonText=">" :finishButtonText="buttonTitle">

      <tab-content title="">
        <LessonTabContent>
              <span class="font-black text-6xl">{{lesson.title | capitalize_1}}</span>

              <div class="lesson-intro-image-wrapper">
                <img class="mx-auto p-4 lesson-intro-image" src="@/assets/images/academy/academy_popup_7.svg"/>
              </div>

        </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
            <div class="w-1/2 mx-auto mt-4">
              <img src="@/assets/images/academy/aca_24.png"/>
            </div>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p class="mb-4 text-3xl">How do you feel when you scroll through social media and see the lives of others?</p>


          <p>How does it make you feel?</p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>When someone in a nicer car stops at a red light next to you? When does someone has a better paid job? When someone has a newer smartphone or more expensive shoes?</p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p>
            Sometimes these feelings can be <span class="font-semibold">motivating and even inspiring</span>, but sometimes they are also entirely unjustified, but they still make you <span class="font-italic">sad and anxious.</span>
          </p>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            And the worst part is that you don't even realize it.
          </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p class="">
            This comparison is an illusion your mind has created.
          </p>

          <p class="mt-2">
            What you see are only <span class="font-semibold">highlights of others' lives.</span>
          </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="">
        <LessonTabContent>
          <p>
            The person in a nicer car may be thinking about a Porsche, the person with better career may be thinking about a different job or has no time to spend with their children, and so on.
          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
            <div class="w-1/2 mx-auto">
              <img src="@/assets/images/academy/aca_26.png"/>
            </div>

       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
          <p>
            <span class="font-semibold">You are different</span> than other people, they are not like you, and you are not like them.
            If you ever wonder if you are unique, then here is a definitive answer: <span class="font-semibold">you are unique.</span> 
          </p>

          <p class="mt-4">
            The question is what you are willing to do about it.
          </p>
       </LessonTabContent>
      </tab-content>

      <tab-content title="">
        <LessonTabContent>
        <p class="text-xl">
           And that's what the whole improvee.io experience is about: 
        </p>

        <p class="text-3xl mt-2">
          Getting to know yourself, working with yourself, and improving yourself compared to your yesterday's self.
        </p>
       </LessonTabContent>
      </tab-content>


      <tab-content title="" :beforeChange="saveAndExit">
        <LessonTabContent>
           <p class="">
             So, what highlight or lowlight will you enter on your timeline?
           </p>

        <div class="mt-2">
            <vs-button color="#5222D0" size="large" @click="redirectToJourney">go to my journey page</vs-button>
          </div>
       </LessonTabContent>
      </tab-content>

    </form-wizard>
  </LessonContent>

</template>

<script>
import LessonContent from './LessonContent'
import LessonTabContent from './LessonTabContent'
import { FormWizard, TabContent } from 'vue-form-wizard'
import LessonMixin from '../../Generic/LessonMixin'

export default {
  components: {
    LessonContent,
    LessonTabContent,
    TabContent,
    FormWizard
  },
  props: ['lesson'],
  mixins: [LessonMixin],
  data () {
    return {}
  },
  computed: {
  },
  methods: {
    redirectToJourney () {
      const routeData = this.$router.resolve({ name: 'journey' })
      window.open(routeData.href, '_blank')
    }
  },
}
</script>
